import { throttle } from 'lodash-es'
import type { Ref } from 'vue'
import { computed, ref } from 'vue'

const SCROLLING_THROTTLE_INTERVAL = 300

export const useMessageViewScrollingControl = (
  isDisabledToScrollToBottom: Ref<boolean>,
  onScrollTopZero: () => void
) => {
  const messageView = ref<HTMLElement | null>(null)

  const scrollMessageViewToBottom = (): void => {
    if (isDisabledToScrollToBottom.value || !messageView.value) {
      return
    }

    messageView.value.scrollTop = messageView.value.scrollHeight
  }

  const throttledMessageViewOnScrollHandler = computed(() => {
    return throttle((): void => {
      if (!messageView.value) {
        return
      }

      if (messageView.value.scrollTop <= 0) {
        onScrollTopZero()

        return
      }

      if (
        !isDisabledToScrollToBottom.value &&
        messageView.value.scrollTop + messageView.value.clientHeight + 500 <
          messageView.value.scrollHeight
      ) {
        isDisabledToScrollToBottom.value = true
        return
      }

      if (
        isDisabledToScrollToBottom.value &&
        messageView.value.scrollTop + messageView.value.clientHeight >=
          messageView.value.scrollHeight
      ) {
        isDisabledToScrollToBottom.value = false
      }
    }, SCROLLING_THROTTLE_INTERVAL)
  })

  return {
    messageView,
    scrollMessageViewToBottom,
    throttledMessageViewOnScrollHandler,
  }
}
